var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#kxgpd9xp3a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.745 10.745 0 24 0h8.2c13.255 0 24 10.745 24 24s-10.745 24-24 24H24C10.745 48 0 37.255 0 24z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.8 24C.8 11.187 11.187.8 24 .8h8.2C45.013.8 55.4 11.187 55.4 24c0 12.813-10.387 23.2-23.2 23.2H24C11.187 47.2.8 36.813.8 24z",
    stroke: "#000",
    strokeOpacity: 0.25,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 18.527c0-.47.223-.941.641-1.218l5.689-4.015c1.617-1.135 3.346 1.301 1.756 2.437l-1.924 1.356h13.332c1.98 0 1.98 2.99 0 2.99H23.902l1.784 1.246c1.618 1.136-.139 3.572-1.756 2.437l-5.689-4.015a1.424 1.424 0 0 1-.641-1.218zm0 11.02c0-.831.67-1.496 1.506-1.496h13.331l-1.924-1.356c-1.589-1.135.14-3.572 1.757-2.437l5.689 4.015c.39.277.641.747.641 1.218 0 .47-.223.942-.641 1.218l-5.689 4.015c-.67.47-1.617.332-2.091-.36-1.088-1.633 1.087-2.547 2.119-3.35H19.106c-.837.028-1.506-.665-1.506-1.467z",
    fill: "#000",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kxgpd9xp3a",
    x: 0,
    y: 0,
    width: 56.2,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_250_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_250_66",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareButton);
export default __webpack_public_path__ + "static/media/compare-button.d71853461cd6714d33458c9dec5746e7.svg";
export { ForwardRef as ReactComponent };